import { createContext } from "react";

export const UserInfo = createContext({ name: "gary", id: "garyIsFree" });
